<script setup lang="ts">
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import PrettyJsonRenderer from '@/components/PrettyJsonRenderer.vue'

interface Props {
  open?: boolean;
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  data: () => []
})

const emit = defineEmits<{
  'update:open': [value: boolean]
}>()

const handleClose = () => {
  emit('update:open', false)
}
</script>

<template>
  <Sheet :open="props.open" @update:open="emit('update:open', $event)">
    <SheetContent class="w-1/2 overflow-hidden flex flex-col bg-slate-100">
      <SheetHeader>
        <SheetTitle>Preview</SheetTitle>
      </SheetHeader>
      <SheetDescription class="flex-1 overflow-y-auto bg-slate-50 rounded-md p-4">
        <PrettyJsonRenderer :data="props.data" />
      </SheetDescription>
    </SheetContent>
  </Sheet>
</template>